import * as $ from 'jquery';
import 'jquery-colorbox';

export default function init() {
	const loadLazy = (img: any) => {
		let $img = $(img);

		$img.attr("src", $img.attr("data-src"));
		$img.attr("srcset", $img.attr("data-srcset"));
		$img.addClass('stop-it');

		$img.removeAttr("data-src");
		$img.removeAttr("data-srcset");
		$img.removeClass('lazy');
	}

	const jqueryElements = $('.inspiration .item[data-has-lightbox="true"]');
	if ((jqueryElements as any).colorbox !== undefined) {
		(jqueryElements as any).colorbox({
			rel: 'gal',
			inline: true,
			href: function() {
				return $(this).find('.item__lightbox');
			},
			transition: 'fade',
			initialWidth: '200',
			initialHeight: '200',
			width: '1256',
			height: '90%',
			maxWidth: '90%',
			//maxHeight: '99%',
			fixed: true,
			reposition: true,
			className: 'lightText',
			close: '\
				<svg xmlns="http://www.w3.org/2000/svg" width="18.103" height="18.103" viewBox="0 0 18.103 18.103">\
					<g data-name="Group 1706" fill="none" stroke="#fcee1e" stroke-width="1.5">\
						<path data-name="Path 1392" d="m.53.53 17.04 17.042"/>\
						<path data-name="Path 1393" d="M.53 17.573 17.57.533"/>\
					</g>\
				</svg>\
				<span>Close</span>',
			previous: '\
				<svg xmlns="http://www.w3.org/2000/svg" width="25.807" height="15.372" viewBox="0 0 25.807 15.372">\
					<g data-name="Group 1614" fill="none" stroke="#fcee1e" stroke-width="1.5">\
						<path data-name="Path 1335" d="M25.807 7.662h-24.1"/>\
						<path data-name="Path 1336" d="M8.216 14.842 1.06 7.686 8.216.53"/>\
					</g>\
				</svg>\
				<span>Previous</span>',
			next: '\
				<svg xmlns="http://www.w3.org/2000/svg" width="25.807" height="15.372" viewBox="0 0 25.807 15.372">\
					<g data-name="Group 1614" fill="none" stroke="#fcee1e" stroke-width="1.5">\
						<path data-name="Path 1335" d="M-.001 7.71h24.1"/>\
						<path data-name="Path 1336" d="m17.59.53 7.156 7.156-7.156 7.156"/>\
					</g>\
				</svg>\
				<span>Next</span>',
			onOpen: () => {
				document.querySelector('html').classList.add('lockScroll');
			},
			/* onComplete: () => {
				// NOTE: This was needed due to T3 Cache plugin on Kona. Was really screwing up height on this site.


				// Images may not be loaded and when when listening for them to be loaded, calling resize() still doesn't
				// always work, so we have to fallback to using a setInterval to be safe and ensure everything works.

				// Resize once now
				//@ts-ignore
				$.colorbox.resize();

				// and start interval to refresh every second until lightbox is closed
				if (resizeInterval !== undefined) {
					clearInterval(resizeInterval);
				}
				//@ts-ignore
				setTimeout(() => $.colorbox.resize(), 200);
				//@ts-ignore
				setTimeout(() => $.colorbox.resize(), 500);
				//@ts-ignore
				resizeInterval = setInterval(() => $.colorbox.resize(), 1000);
			}, */
			onClosed: () => {
				document.querySelector('html').classList.remove('lockScroll');

				// Stop interval
				/* clearInterval(resizeInterval);
				resizeInterval = undefined; */
			}
		});
	}
}
